import { render } from "./HeroiconsSolidLogout.vue?vue&type=template&id=c358ff56"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLogout.vue"]])

export default __exports__